import { useEffect, useState } from 'react'

export type Countdown = {
  hours: string
  minutes: string
  seconds: string
}

const pad = (value: number): string => String(value).padStart(2, '0')

export function useCountdown(initialSeconds: number): Countdown {
  const [remaining, setRemaining] = useState<number>(initialSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((current) => (current <= 0 ? 0 : current - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
